import React from "react";
import PropTypes from "prop-types";

import { Layout } from "antd";
import Sidebar from "../commom/components/sidebar";
import Topbar from "../commom/components/topbar";

const { Content, Footer } = Layout;

const displayName = "Private Layout";
const propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object
};

function PrivateLayout({ children, location }) {
  return (
    <Layout>
      <Sidebar location={location} />

      <Layout>
        <Topbar />

        <Content className="content-layout">{children}</Content>

        <Footer>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
            <p>Firstoeat &copy; 2026 - Versão 2.00.00</p>
            <p>Powered by <a href="https://workarea.com.br" target="_blank">WorkArea</a></p>
          </div>
        </Footer>
      </Layout>
    </Layout>
  );
}

PrivateLayout.dispatch = displayName;
PrivateLayout.propTypes = propTypes;

export default PrivateLayout;
